import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getuserdata } from '../services/apiService';
import AddHospitalDoctor from './Components/AddHospitalDoctor';

const HospitalAddDoctor = () => {
    const navigate = useNavigate();
    const [hospital, setHospital] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getHospitalId();
    }, []);

    const getHospitalId = async () => {
        try {
            const hospitalData = await getuserdata("full");
            console.log('Hospital data:', hospitalData);
            setHospital(hospitalData);
        } catch (error) {
            console.error('Error fetching hospital data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSuccess = () => {
        // Navigate back to doctors list after successful addition
        navigate('/hospital/mydoctors');
    };

    const handleCancel = () => {
        // Navigate back to doctors list on cancel
        navigate('/hospital/mydoctors');
    };

    if (loading) {
        return (
            <div className="dc-haslayout dc-dbsectionspace">
                <div className="container-fluid py-3">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card">
                    <div className="card-header">
                        <h5 className="mb-0">Add Doctor to Hospital</h5>
                    </div>
                    <div className="card-body">
                        <AddHospitalDoctor
                            visible={true}
                            onCancel={handleCancel}
                            onSuccess={handleSuccess}
                            hospitalId={hospital.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalAddDoctor;
